@use "variables" as *;

.ul {
  padding: $spacing-s $spacing-s $spacing-xs $spacing-s;
}

.name {
  font-size: $fontSize-xl;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
}

.subtitle {
  font-size: $fontSize-m;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  width: 30%;
}

.grades {
  font-size: $fontSize-ml;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  width: 50%;
}
